<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "Reset Password" | translate }}</h3>
    <p>
      {{
        "Welcome Back! Reset your password to can login to have full access"
          | translate
      }}
    </p>

    <div class="mt-3">
      <label>{{ "New Password" | translate }}</label>
      <div class="input-container mt-1">
        <i class="bi bi-lock left-icon"></i>

        <input
          type="{{ showPassword ? 'text' : 'password' }}"
          [(ngModel)]="password"
          placeholder="{{ 'Enter your new password' | translate }}"
        />

        <i
          class=" eye-icon {{ showPassword ? 'bi-eye-slash' : 'bi bi-eye ' }}"
          (click)="toggleShowPassword()"
        ></i>
      </div>
    </div>
    <div class="mt-3">
      <label>{{ "Confirm New Password" | translate }}</label>
      <div class="input-container mt-1">
        <i class="bi bi-lock left-icon"></i>

        <input
          type="{{ showConfirmPassword ? 'text' : 'password' }}"
          [(ngModel)]="confirmPassword"
          placeholder="{{ 'Renter your new password' | translate }}"
        />

        <i
          class=" eye-icon {{
            showConfirmPassword ? 'bi-eye-slash' : 'bi bi-eye '
          }}"
          (click)="toggleConfirmShowPassword()"
        ></i>
      </div>
    </div>

    <button (click)="resetPassword()" class="w-100 gradient-button mt-5">
      {{ "Reset Password" | translate }}
    </button>

    <div class="text-center mt-4">
      {{ "Login with another account?" | translate }}
      <span class="bold-text" routerLink="/login">{{
        "Login" | translate
      }}</span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 right-container">
    <img width="20%" src="../../../../assets/img/logo.png" />
    <br />
    <img width="80%" class="mt-3" src="../../../../assets/img/authGroup.svg" />
  </div>
</div>
